// @ts-expect-error untyped
import SafeStorage from 'SafeStorage';
import { logRavenException } from 'ui-deal-management-components-lib/utils/ravenWrapperUtil';
export const getStorageValue = key => {
  try {
    const value = SafeStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch (e) {
    logRavenException(e, 'getStorageValue exception', {
      key
    });
    return null;
  }
};
export const setStorageValue = (key, value) => {
  try {
    SafeStorage.setItem(key, value);
  } catch (e) {
    logRavenException(e, 'setStorageValue exception', {
      key
    });
    return;
  }
};